import React, { useState, useEffect } from 'react';
import {
  Grid,
  Column,
  DataTable,
  Pagination,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Theme,
} from '@carbon/react';
import { getResoucesForViews } from '../../services/services';
import CommodityHeader from '../../components/Header';
import { useNavigate } from "react-router-dom";
import SessionController from '../../components/FrontSessionController/SessionController';

const headers = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'name',
    header: 'Name',
  },
  {
    key: 'mail',
    header: 'Mail',
  }
];


const ViewManagers = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  const [rows, setRows] = useState([]);
  const [messageSessionLost, setMessageSessionLost] = useState('');

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  }

  const getManagersList = async (request) => await getResoucesForViews(request)
  .then(response => {
    if(response.status === 200){
      response.json()
        .then(response => {
          parserIdInResponse(response);
        })
    } else if(response.status === 410)   {
      response.text()
        .then(res => {
          setMessageSessionLost(res)                             
        })
    }  
  });

  const parserIdInResponse = (response) => {
    const resParsed = response.map((res, i) => {
      const parsed = {};
      parsed["id"] = i.toString();
      parsed["ctrycode"] = res.ctrycode;
      parsed["mail"] = res.mail;
      parsed["name"] = res.name;
      return parsed;
    });
    setRows(resParsed);
  };

  const goHomeScreen = () => {
    navigate('/home')
  };

  useEffect(() => {
    const request = {};
    request.viewName = 'viewManagers';
    getManagersList(request);    
  }, [0]);


  return (
    <>
      <h2 className="table-title">Manager's List</h2>

      <Grid>
        <Theme theme="g90">
            <CommodityHeader />
        </Theme>
        <Column className="style-column-datatable-managers" lg={16} >
          <Button className='style-bttbackID' size="lg" onClick={goHomeScreen}>Back to Home</Button>
          <DataTable
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              onInputChange
            }) => (

              <TableContainer>
                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                    {/* pass in `onInputChange` change here to make filtering work */}
                  </TableToolbarContent>
                </TableToolbar>
                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>

                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row, i) => (
                      <TableRow {...getRowProps({ row })}>
                        {row.cells.map(cell => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination
                  onChange={changePaginationState}

                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />
        </Column>
        <SessionController messageLostSessionCallback={messageSessionLost} />
      </Grid>
    </>
  );
};

export default ViewManagers;